import api from "../config/api";

export function getCookie(name) {
  if (typeof document === "undefined") return null;

  const match = document.cookie.match(
    new RegExp(`(^| )${name}=([^;]+)`)
  );

  return match ? decodeURIComponent(match[2]) : null;
}

export function hasCheckProfileUser(user) {
  return Boolean(user?.mobile);
}

export async function getCheckProfileUser(profileId = getCookie("profileId")) {
  if (!profileId) return null;

  try {
    const response = await api.post(
      "/user/check-profile",
      { profileId },
      { withCredentials: true }
    );

    return response?.data?.user || null;
  } catch (error) {
    console.error("check-profile failed:", error);
    return null;
  }
}

export async function shouldRedirectToWelcomeScreen() {
  const user = await getCheckProfileUser();
  return hasCheckProfileUser(user);
}